/**
 * @description 长页面中每个tab需要跳转到的位置，都添加一个 tabAnchor 组件
 */

import React from 'react';

export default function TabAnchor() {
    return (
        <div className="tab-anchor"></div>
    );
}
